(() => {
  const ACCESS_KEY = 'etMuseumAccessGranted_v322';
  const INTERNAL_NAV_KEY = 'etMuseumInternalNavigation_v322';
  const PENDING_EXIT_KEY = 'etMuseumPendingExit';
  const PENDING_ENTER_KEY = 'etMuseumPendingEnter';
  const hasAccess = () => {
    try { return sessionStorage.getItem(ACCESS_KEY) === 'true' || localStorage.getItem(ACCESS_KEY) === 'true'; }
    catch (_) { return false; }
  };

  const clearLegacyAccess = () => {
    try {
      ['etMuseumAccessGranted_v320','etMuseumAccessGranted_v319','etMuseumAccessGranted_v318','etMuseumAccessGranted_v317'].forEach((key) => {
        localStorage.removeItem(key); sessionStorage.removeItem(key);
      });
    } catch (_) {}
  };
  const bootstrapAccessState = () => {
    let internal = false;
    try {
      internal = sessionStorage.getItem(INTERNAL_NAV_KEY) === 'true';
      sessionStorage.removeItem(INTERNAL_NAV_KEY);
    } catch (_) {}
    let forceExit = false;
    try { forceExit = new URLSearchParams(window.location.search).get('museum_exit') === '1'; } catch (_) {}
    const externalArrival = !document.referrer || (() => { try { return new URL(document.referrer).origin !== window.location.origin; } catch (_) { return true; } })();
    if (forceExit || (window.location.pathname === '/' && externalArrival && !internal)) {
      try { localStorage.removeItem(ACCESS_KEY); sessionStorage.removeItem(ACCESS_KEY); } catch (_) {}
      clearLegacyAccess();
      try { history.replaceState({}, '', window.location.pathname); } catch (_) {}
    }
  };
  bootstrapAccessState();
  document.addEventListener('click', (event) => {
    if (!hasAccess()) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    try {
      const url = new URL(link.href, window.location.href);
      if (url.origin === window.location.origin && !link.hasAttribute('download') && link.target !== '_blank') {
        sessionStorage.setItem(INTERNAL_NAV_KEY, 'true');
      }
    } catch (_) {}
  }, true);

  const requestEnter = () => {
    const museum = document.querySelector('[data-et-museum]');
    if (museum) {
      document.dispatchEvent(new CustomEvent('et:show-museum-doors'));
      return;
    }
    try { sessionStorage.setItem(PENDING_ENTER_KEY, 'true'); } catch (_) {}
    window.location.assign('/?museum_enter=1');
  };
  const exitMuseum = () => {
    const museum = document.querySelector('[data-et-museum]');
    if (museum) {
      document.dispatchEvent(new CustomEvent('et:exit-museum'));
      return;
    }
    try {
      localStorage.setItem(PENDING_EXIT_KEY,'true');
      sessionStorage.setItem(PENDING_EXIT_KEY,'true');
    } catch (_) {}
    window.location.assign('/?museum_exit=1');
  };
  const ensureButton = () => {
    document.querySelectorAll('[data-et-global-museum-exit]').forEach((node) => node.remove());
    const icons = document.querySelector('.header__icons');
    if (!icons) return;
    let button = icons.querySelector('[data-et-header-museum-exit]');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'et-museum-header-exit header__icon link focus-inset';
      button.setAttribute('data-et-header-museum-exit','');
      const account = icons.querySelector('.header__icon--account');
      if (account) icons.insertBefore(button, account); else icons.prepend(button);
      button.addEventListener('click', () => hasAccess() ? exitMuseum() : requestEnter());
    }
    const inside = hasAccess();
    button.classList.toggle('is-enter', !inside);
    button.classList.toggle('is-exit', inside);
    button.setAttribute('aria-label', inside ? 'Exit Earth Treasures Museum' : 'Enter Earth Treasures Museum');
    button.innerHTML = inside ? `
      <svg viewBox="0 0 40 40" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M7 34h18V7H7z"/><path d="M10 10h12v21H10z"/><path d="M17.5 20.5h.2"/>
        <path d="M25 20h10"/><path d="m31 16 4 4-4 4"/><path d="M5 34h23"/>
      </svg><span class="et-exit-label">Exit</span>` : `
      <svg viewBox="0 0 40 40" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M15 34h18V7H15z"/><path d="M18 10h12v21H18z"/><path d="M24.5 20.5h.2"/>
        <path d="M4 20h11"/><path d="m8 16-4 4 4 4"/><path d="M12 34h23"/>
      </svg><span class="et-exit-label">Enter</span>`;
    document.body.classList.toggle('et-museum-access-granted', inside);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensureButton); else ensureButton();
  window.addEventListener('pageshow', ensureButton);
  document.addEventListener('shopify:section:load', ensureButton);
  document.addEventListener('et:museum-access-changed', ensureButton);
  setInterval(ensureButton, 1200);
})();
